import React, { useState } from 'react';
import styled from '../styled';
import { TextInput } from '../paper';

import * as Colors from '../../helpers/Colors';
import { TextField } from '../Input';
import { CustomModal } from '../Modal';
import SelectableRow from '../SelectableRow';
import { Keyboard } from '../../web/react-native';

interface Item {
  key: string;
  label?: string;
  value: string;
}
interface SelectorProps {
  name?: string;
  title?: string;
  value: Item;
  items: Item[];
  disabled?: boolean;
  onValueChange?: ((...args: any[]) => any) | undefined;
}

export const Selector: React.FC<SelectorProps> = ({
  name,
  onValueChange,
  title,
  disabled,
  value,
  items,
}) => {
  const [selected, setSelected] = useState<Item>(value);
  const [isPickerVisible, setIsPickerVisible] = useState<boolean>(false);

  const handlePressed = () => {
    if (!disabled) {
      setIsPickerVisible(true);
      Keyboard.dismiss();
    }
  };

  return (
    <>
      <TextField
        disabled={disabled}
        showSoftInputOnFocus={false}
        value={selected.label ? selected.label : selected.value}
        onPressIn={handlePressed}
        caretHidden
        right={
          <TextInput.Icon
            style={{ marginTop: 13 }}
            disabled={disabled}
            name="chevron-down"
            color={Colors.disabledForeground}
            onPress={handlePressed}
          />
        }
      />
      <PickerModal
        title={title}
        isVisible={isPickerVisible}
        dismissModal={() => setIsPickerVisible(false)}>
        {items &&
          items.map((item) => (
            <SelectableRow
              key={item.key}
              title={item.label ? item.label : item.value}
              isSelected={item.key === selected.key}
              onSelection={() => {
                setSelected(item);
                setIsPickerVisible(false);
                if (name) onValueChange?.(name, item.value);
              }}
            />
          ))}
      </PickerModal>
    </>
  );
};

const PickerModal = styled(CustomModal)``;
